import { render, staticRenderFns } from "./HelpTypeList.vue?vue&type=template&id=9d93eaba"
import script from "./HelpTypeList.vue?vue&type=script&lang=js"
export * from "./HelpTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports